import { gracefulFetch } from './gracefulFetch';

interface Props {
  state: {};
  values: {};
}

export const postHelpForm = async ({ state, values }: Props) => {
  let response: Response | null = null;

  try {
    response = await gracefulFetch({
      fetch: async () =>
        fetch('https://nect.com/code/help-form.php', {
          method: 'POST',
          headers: {
            'X-API-KEY': '3d6a12fa43-c0a6-492c-b99b-29934cb6aff6'
          },
          body: JSON.stringify({
            ...state,
            ...values
          })
        })
    });
  } catch (e) {
    console.warn(e);
  }

  return response;
};
